export default __webpack_public_path__ + "static/bg-superhuman-ai--mobile-df88d513124a1c4c875abd26135fba68.webp";